"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialIcon = exports.DemoTextArea = exports.DemoIcon = exports.DemoDiv = exports.DemoWrapper = exports.StyledSvg = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledSvg = styled_components_1.default.svg({ transition: 'all .2s linear' });
exports.DemoWrapper = styled_components_1.default.div((_a = {
        display: 'inline-flex',
        width: '100%'
    },
    _a[theme_1.mediaQuery(theme_1.breakpoints.md)] = {
        width: '50%'
    },
    _a[theme_1.mediaQuery(theme_1.breakpoints.lg)] = {
        width: '25%'
    },
    _a));
exports.DemoDiv = styled_components_1.default.div({
    background: theme_1.colors.white,
    borderColor: theme_1.colors.grey3,
    borderStyle: 'solid',
    borderWidth: '1px',
    boxSizing: 'border-box',
    display: 'inline-flex',
    flexDirection: 'column',
    height: '100px',
    justifyContent: 'center',
    margin: theme_1.scaffolding.sm,
    padding: theme_1.scaffolding.md,
    position: 'relative',
    textAlign: 'center',
    transition: 'all .2s linear',
    width: '100%'
});
exports.DemoIcon = styled_components_1.default.div({
    margin: '10px 0px'
});
exports.DemoTextArea = styled_components_1.default.textarea(__assign(__assign({ ':hover': {
        borderColor: theme_1.colors.grey4
    } }, theme_1.font), { borderColor: theme_1.colors.grey2, cursor: 'pointer', minHeight: '18px', outline: 0, resize: 'none', textAlign: 'center', transition: 'all .2s linear' }));
exports.MaterialIcon = styled_components_1.default.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: all .2s linear;\n  text-align: left;\n  font-size: ", ";\n  pointer-events: all;\n"], ["\n  transition: all .2s linear;\n  text-align: left;\n  font-size: ", ";\n  pointer-events: all;\n"])), function (_a) {
    var iconSize = _a.iconSize;
    return iconSize ? "" + iconSize : 'inherit';
});
var templateObject_1;
//# sourceMappingURL=styles.js.map